import BackArrow from '@cashew/back-arrow';
import Title from '@cashew/title';
import type { order } from '@cashew/types';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { PageWithNavigation, SubscriptionHistoryItem } from '../../components';
import NotificationBadge from '../../components/NoteBox';
import SubscriptionDetailPage from '../../components/SubscriptionDetail';
import Timeline from '../../components/Timeline';
import { initialOrder } from '../../helpers/initialorder';
import Dispatch from '../Dispatch';
import useOrderDetailsTimeline from '../Order-Detail/hooks/useOrderDetailsTimeline';

const { api } = require('@cashew/utils');

const ns = 'subscription-detail';

const useGetOrderDetails = (
  orderId: string,
  setOrderDetails: any,
  setLoading: any,
  dispatch: any,
  t: any
) => {
  setLoading(true);
  api
    .get({
      endpoint: `orders/${orderId}`,
    })
    .then(async (resp: any) => {
      const hasCustomer = false;
      // const hasCustomer = !!resp.data.customer;
      if (!hasCustomer) {
        await api
          .get({
            endpoint: `orders/${orderId}/customer`,
          })
          .then((customerResponse: any) => {
            // eslint-disable-next-line no-param-reassign
            resp.data.customer = customerResponse.data;
          })
          .catch((error: any) => {
            console.log(error);
          });
      }
      setOrderDetails(resp.data);
    })
    .catch(() =>
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: t('orderDetails.error.fetchDetails.title'),
          toasterMessage: t('orderDetails.error.fetchDetails.message'),
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      })
    )
    .finally(() => {
      setLoading(false);
    });
};

/**
 * Orders Page RefundPage
 */
export default () => {
  const { t } = useTranslation();
  const { language } = useSelector((state: any) => state.user);
  const params: any = useParams();
  const history = useHistory();
  const [orderDetails, setOrderDetails] = useState<order.OrderType | any>(
    initialOrder
  );
  const [, setLoading] = useState(false);
  const dispatch = useDispatch();
  const productType = useMemo(
    () =>
      orderDetails?.productType === 'SUBSCRIPTION' ? 'subscription' : 'order',
    [orderDetails?.productType]
  );

  const { data: timelineDetails = [], loading: isTimelineLoading } =
    useOrderDetailsTimeline(params?.orderId);

  useEffect(() => {
    useGetOrderDetails(
      params.orderId,
      setOrderDetails,
      setLoading,
      dispatch,
      t
    );
  }, [params.orderId]);
  return (
    <div className={ns}>
      <Helmet>
        <title>{t('subscription.details')}</title>
      </Helmet>
      <PageWithNavigation showStores={false}>
        <Title className={`${ns}__title`}>
          {`Subscription ${params.orderId}`}
          <BackArrow
            to={`/${language}/subscriptions`}
            title="Back to subscriptions"
          />
        </Title>

        <SubscriptionDetailPage
          t={t}
          useSelector={useSelector}
          type="admin"
          history={history}
          dispatch={Dispatch}
          Link={Link}
          orderId={params.orderId}
          moment={moment}
          NotificationBadge={NotificationBadge}
          SubscriptionHistoryItem={SubscriptionHistoryItem}
          language={language}
        />

        {productType === 'subscription' && (
          <Timeline
            timelineDetails={timelineDetails}
            loading={isTimelineLoading}
            type={productType}
            isPayNow={false}
            currency={orderDetails.currencyCode}
          />
        )}
      </PageWithNavigation>
    </div>
  );
};
